/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Loyalty bonuses and discount settings
 */
export interface LoyaltyBonusesSettingsApiModel {
  /**
   * Limit bonus points redeem in percentage of check amount
   */
  bonus_payment_limit?: number;
  /**
   * Bonus points payment settings source (optional)
   */
  bonus_payment_settings_source?: LoyaltyBonusesSettingsApiModelBonusPaymentSettingsSourceEnum | null;
  /**
   * Bonus points redeem type (only full check amount, partial check amount, partial check amount rounded to the nearest whole number)
   */
  bonus_payment_type?: LoyaltyBonusesSettingsApiModelBonusPaymentTypeEnum;
  /**
   * Limit bonus points redeem amount without PIN confirmation
   */
  unconfirmed_bonus_payment_amount?: number;
  /**
   * Limit discount amount without PIN confirmation
   */
  unconfirmed_discount_amount?: number;
}
export enum LoyaltyBonusesSettingsApiModelBonusPaymentSettingsSourceEnum {
  Loyalty = 'loyalty',
  CardCategory = 'card-category'
}
export enum LoyaltyBonusesSettingsApiModelBonusPaymentTypeEnum {
  FullCheck = 'full-check',
  Partial = 'partial',
  PartialRounded = 'partial-rounded'
}
